import Vue from "vue";
import Vuex from "vuex";
import sharedMutations from "vuex-shared-mutations";

import auth from "./modules/auth";
import balance from "./modules/balance";
import paymentMethods from "./modules/payment-methods";
import payoutMethods from "./modules/payout-methods";
import payouts from "./modules/payouts";
import proposal from "./modules/proposal";
import savedUsersCount from "./modules/saved-users-count";
import schedulerInbox from "./modules/scheduler-inbox";

Vue.use(Vuex);

const debug = process.env.NODE_ENV === "production";

export default new Vuex.Store({
    modules: {
        auth,
        proposal,
        savedUsersCount,
        schedulerInbox,
        paymentMethods,
        payoutMethods,
        payouts,
        balance,
    },
    strict: debug,
    plugins: [
        sharedMutations({
            predicate: ["auth/setAuthUserInfo", "auth/setAuthenticated"],
        }),
    ],
});
